import { connect } from "react-redux";
import ArticleDetailLayout from "../components/ArticleDetailLayout";
import { fetchArticle, clearArticleData } from "../actions/index";
import { isFromApp } from "../selectors/index";
import { getShareUrl, getDataReceived, getDataRequested } from "../selectors/articles";
const mapStateToProps = (state, ownProps) => ({
    articleDataRequested: getDataRequested(state, ownProps.params.slug),
    articleDataReceived: getDataReceived(state, ownProps.params.slug),
    shareUrl: getShareUrl(state, ownProps.params.slug),
    articleData: state.getIn(["articlesData", ownProps.params.slug, "data"]),
    isFromApp: isFromApp(state),
    searchParams: ownProps.location.search
});
const mapDispatchToProps = (dispatch) => ({
    fetchArticleDetails: ({ slug }) => dispatch(fetchArticle({ slug })),
    clearArticleData: (slug) => dispatch(clearArticleData(slug))
});
const ArticleWithSubscription = connect(mapStateToProps, mapDispatchToProps)(ArticleDetailLayout);
// set static on this component
// for its preload chunk
ArticleWithSubscription.preloadChunkName = "ArticlePage";
ArticleWithSubscription.cacheString = "public, max-age=120";
export default ArticleWithSubscription;
